import React from 'react';
import { cn } from '@shared/lib/utils';
import { SettingsMenu } from './settings-menu';
import paygatexLogo from '@shared/assets/paygatex-sidebar.png';
import { UserMenu } from './user-menu';

interface MobileBarProps {
  leading: React.ReactNode;
  className?: string;
}

/** Shared top row for the mobile shell: leading control, logo, settings and profile. */
export function MobileBar({ leading, className }: MobileBarProps): React.ReactElement {
  return (
    <div
      className={cn(
        'flex h-topbar items-center gap-2 xs:gap-3',
        'px-[var(--layout-page-padding-x-mobile)] sm:px-[var(--layout-page-padding-x-tablet)]',
        className
      )}
    >
      {leading}

      <img
        src={paygatexLogo}
        alt="Paygatex"
        className="h-logo-h w-logo-w shrink-0 object-contain object-left"
      />

      <div className="ml-auto flex items-center gap-1 xs:gap-2">
        <SettingsMenu iconClassName="size-header-icon" />
        <UserMenu />
      </div>
    </div>
  );
}
